import { graphql } from '@/gql';
import { type PaymentScheduleStageFieldsFragment } from '@/gql/graphql';
import { type StoredPaymentScheduleStage } from '@payaca/types/payment-schedule';
import { assertUnreachable } from '@payaca/utilities/guards';

export const PaymentScheduleStageFields = graphql(`
  fragment PaymentScheduleStageFields on PaymentScheduleStage {
    __typename
    ... on DepositPaymentStage {
      description
      basis {
        __typename
        ... on PercentageDepositBasis {
          percentageDue
        }
        ... on FixedDepositBasis {
          fixedAmount
          percentageCap
        }
      }
    }
    ... on InstalmentPaymentStage {
      description
      percentageDue
    }
  }
`);

export const toStoredPaymentScheduleStage = (
  stage: PaymentScheduleStageFieldsFragment
): StoredPaymentScheduleStage => {
  switch (stage.__typename) {
    case 'InstalmentPaymentStage':
      return {
        type: 'instalment',
        description: stage.description,
        percentageDue: stage.percentageDue,
      };
    case 'DepositPaymentStage':
      return stage.basis.__typename === 'FixedDepositBasis'
        ? {
            type: 'deposit',
            description: stage.description,
            basis: {
              type: 'fixed',
              fixedAmount: stage.basis.fixedAmount,
              percentageCap: stage.basis.percentageCap ?? null,
            },
          }
        : {
            type: 'deposit',
            description: stage.description,
            basis: {
              type: 'percentage',
              percentageDue: stage.basis.percentageDue,
            },
          };
    default:
      return assertUnreachable(stage);
  }
};
